/**
 * 数値を全角数字の文字列に変換する関数
 * @param num 変換対象の数値
 * @returns 全角数字に変換された文字列
 */
export const convertNumberToFullWidthDigits = (num: number): string => {
  const str = num.toString(); // 数値を文字列に変換
  return str.replace(/[0-9]/g, (s) =>
    String.fromCharCode(s.charCodeAt(0) + 0xfee0)
  );
};

// 日付を "yyyy-MM-dd" の形式に変換
export const formatDate = (date: Date) => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // 月は0から始まるため +1
  const day = date.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// 日付を "yyyy-MM-dd 00:00:00" の形式に変換
export const formatStartDate = (date: Date) => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // 月は0から始まるため +1
  const day = date.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}  00:00:00`;
};

// 日付を "yyyy-MM-dd 23:59:59" の形式に変換
export const formatEndDate = (date: Date) => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // 月は0から始まるため +1
  const day = date.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}  23:59:59`;
};

// タイトルを作成
export const createTitle = (page: string) => {
  const system = "ハーネスアラート";
  return `${page}｜${system}`;
};

export const maskString = (text: string | null | undefined): string => {
  if (!text) return ""; // null や undefined の場合は空文字を返す

  const length = text.length;
  return "*".repeat(length);
  // ? "*".repeat(length - 4) + text.slice(-4) // 最後の4桁のみ表示
  // : text; // 4桁以下ならそのまま表示
};
